/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get("free-shipping")) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      let amount_text = this.querySelector(".free-shipping--text span");
      this.remainingText = this.querySelector(".free-shipping--text-remaining");
      this.fullText = this.querySelector(".free-shipping--text-full");
      let percentage = 1;
      let total = eval(document.getElementById("free-shipping-total").value);
      let minimum = eval(document.getElementById("free-shipping-min").value);

      if (total < minimum) {
        percentage = eval(
          document.getElementById("free-shipping-percent").value
        );
        this.remainingText.style.display = "block";
        this.fullText.style.display = "none";
      } else {
        this.remainingText.style.display = "none";
        this.fullText.style.display = "block";
      }

      this.style.setProperty("--percentage", percentage);
    }
  }
  customElements.define("free-shipping", FreeShipping);
}
